"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _TitlePaper = _interopRequireDefault(require("./TitlePaper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * テーブルラップ部品
 * @prop {string, object} title - タイトル
 * @prop {string, object} help - ヘルプ
 * @prop {string} className - className
 * @prop {array} actions - 一覧下部に表示するアクション用コンポーネント
 * @prop {bool} enableAccordion - アコーディオン有効フラグ
 */
class WrapTable extends _react.default.Component {
  render() {
    const {
      actions,
      title,
      help,
      className,
      children,
      enableAccordion
    } = this.props;
    return enableAccordion ? /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      title: title,
      help: help,
      className: className,
      actions: actions
    }, children) : /*#__PURE__*/_react.default.createElement(_TitlePaper.default, {
      title: title,
      className: className,
      actions: actions
    }, children);
  }
}
exports.default = WrapTable;
WrapTable.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  help: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  className: _propTypes.default.string,
  actions: _propTypes.default.arrayOf(_propTypes.default.node),
  enableAccordion: _propTypes.default.bool
};